import React, { useEffect, useState } from 'react'
import './index.scss'

function ReturnDocusign() {

    setInterval(() => {
      window.close();
    }, 700)

  return (
    <div className="not-found">
        <h2>
        Assinatura realizada com sucesso!
        </h2>
    </div>
  )
}

export default ReturnDocusign
